import React from "react";

class SmsCreditDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      smsCredit: this.getSmsCreditFromStorage()
    };
  }

  getSmsCreditFromStorage = () => {
    try {
      const loginOBJ = localStorage.getItem("login");
      if (!loginOBJ) return 0;
      const loginData = JSON.parse(loginOBJ);
      return loginData.smscredit || 0;
    } catch (e) {
      return 0;
    }
  };

  // Update state when localStorage changes (in other tabs/windows)
  handleStorageChange = (event) => {
    if (event.key === "login") {
      const newCredit = this.getSmsCreditFromStorage();
      this.setState({ smsCredit: newCredit });
    }
  };

  componentDidMount() {
    window.addEventListener("storage", this.handleStorageChange);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this.handleStorageChange);
  }

  render() {
    return (
      <span style={{ color: "#768e9d", fontSize: "12px" }}>
        SMS Credit: $<span id="divsmsCredit">{this.state.smsCredit}</span>
      </span>
    );
  }
}

export default SmsCreditDisplay;
